import type { ReactElement } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function InsideSpacePdSkeleton(): ReactElement {
    return (
        <div aria-hidden="true" className="flex w-full flex-col gap-4 px-4 py-4" data-testid="inside-space-pd-skeleton">
            <Skeleton className="mx-auto h-6 w-40" />
            <div className="grid grid-cols-2 gap-3">
                <Skeleton className="aspect-[4/3] w-full rounded-none" />
                <Skeleton className="aspect-[4/3] w-full rounded-none" />
            </div>
        </div>
    );
}

export default InsideSpacePdSkeleton;
